import React from "react";
import { Quote, TrendingDown } from "lucide-react";

export default function Story() {
  return (
    <section data-testid="story-section" className="bg-white fs-section border-y border-black/5">
      <div className="fs-container">
        <div className="flex items-center gap-3 mb-5">
          <span className="h-px w-8 bg-[#C9A84C]" />
          <span className="fs-tag">The Real Story Behind This Offer</span>
        </div>

        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-7">
            <Quote className="text-[#C9A84C] mb-5" size={38} strokeWidth={1.4} />
            <blockquote
              className="font-display text-3xl md:text-4xl lg:text-5xl leading-[1.05] tracking-[0.02em] uppercase text-[#0A0F1E]"
              data-testid="story-pullquote"
            >
              "We walked in ready to book their event space. We asked in person.
              We went to their website. We still couldn't get a price. So we
              went somewhere else.{" "}
              <span className="text-[#0F172A]/45">They never even knew we were there.</span>"
            </blockquote>
          </div>

          <div className="lg:col-span-5 space-y-6 text-[#0F172A]/80 leading-relaxed">
            <p>
              Last week, we visited a brand new restaurant for a business
              meeting. We loved their private event space — we were already
              picturing monthly bookings. We asked the manager about pricing.
              She didn't know. She referred us to their website. Their website
              didn't have the information either. So we left.
            </p>
            <p>
              We were qualified buyers with real budget, ready to sign. The
              restaurant had no idea they were being evaluated. They ended that
              day thinking it was just a slow afternoon.
            </p>

            <div
              data-testid="loss-callout"
              className="mt-4 flex items-start gap-4 rounded-lg border border-[#C9A84C]/40 bg-[#0A0F1E] p-5"
            >
              <TrendingDown className="text-[#C9A84C] mt-0.5 shrink-0" size={22} strokeWidth={1.8} />
              <p className="text-white/85 text-sm leading-relaxed">
                They potentially lost{" "}
                <span className="font-semibold text-[#C9A84C]">$36,000+</span>{" "}
                in annual event revenue from us alone. From one unanswered
                question.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
